<template>
  <j-modal :title="title" v-dragModal :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item :label="$t('处理人类型')" prop="fixType">
                <a-select :placeholder="$t('请选择处理人类型')" v-model="model.fixType" @change="fixTypeChange" :disabled="fixDisableSubmit">
                  <a-select-option :value="0">{{ $t('指定人员') }}</a-select-option>
                  <a-select-option :value="1">{{ $t('指定班组') }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <template v-if="model.fixType == 0">
              <a-col :span="12">
                <a-form-model-item :label="$t('处理人员选择')" prop="fixUserId">
                  <a-select :placeholder="$t('请选择人员')" v-model="model.fixUserId" @change="handleChange" :disabled="fixDisableSubmit">
                    <a-select-option :value="item.userId" v-for="item in userList" :disabled="item.disabled">{{item.userName}}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('处理人电话')" prop="fixPhone">
                  <a-input v-model="model.fixPhone" :placeholder="$t('请输入处理人电话')" :disabled="fixDisableSubmit"></a-input>
                </a-form-model-item>
              </a-col>
            </template>
            <template v-else>
              <a-col :span="24">
                <a-form-model-item :label="$t('处理班组选择')" prop="fixTeamId">
                  <a-select :placeholder="$t('请选择班组')" v-model="model.fixTeamId" :disabled="fixDisableSubmit">
                    <a-select-option :value="item.id" v-for="item in teamList">{{item.teamName}}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </template>
            <!-- <a-col :span="24">
              <a-form-model-item label="备注" prop="remark">
                <a-textarea v-model="model.remark" placeholder="请输入备注描述" :rows="4" :disabled="fixDisableSubmit" />
              </a-form-model-item>
            </a-col> -->
            <a-col :span="24" v-if="model.repairState == 1">
              <a-form-model-item :label="$t('报修修理描述')" prop="fixDescription">
                <a-textarea v-model="model.fixDescription" :placeholder="$t('请输入报修修理描述')" :rows="4" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  import {
    JeecgListMixin
  } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import {PhoneNumberPattern} from '@/utils/regPattern'
  export default {
    mixins: [JeecgListMixin],
    name: 'assignModal',
    components: {},
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          editState: "/jeecg-engineering/engineering/meterRepair/editState",
          queryById: "/jeecg-engineering/engineering/meterRepair/queryById",
          userList: "/jeecg-engineering/ticket/ticketsUser/list",
          teamList: "/jeecg-engineering/ticket/ticketsTeam/list",
          list: "null",
        },
        fixDisableSubmit: false,
        userList:[],
        teamList:[]
      }
    },
    computed: {
      validatorRules() {
        return {
          fixType: [{
            required: true,
            message: this.$t('请选择处理人类型'),
            trigger: 'change'
          }],
          fixUserId: [{
            required: true,
            message: this.$t('请选择处理人员'),
            trigger: 'change'
          }],
          fixPhone: [{
            required: true,
            message: this.$t('请输入投诉处理人联系方式'),
            trigger: 'blur'
          },{pattern: PhoneNumberPattern,message: this.$t('请输入正确的手机号码')}],
          fixDescription: [{
            required: true,
            message: this.$t('请输入处理描述'),
            trigger: 'blur'
          }],
          fixTeamId: [{
            required: true,
            message: this.$t('请选择处理班组'),
            trigger: 'change'
          }]
        }
      }
    },
    methods: {
      fixTypeChange(e){
        if(e == 0){
          this.$set(this.model,'fixTeamId','');
        }else{
          this.$set(this.model,'fixName','');
          this.$set(this.model,'fixPhone','');
          this.$set(this.model,'fixUserId','');
        }
      },
      handleChange(e){
        let user = this.userList.find(u=>u.userId == e);
        this.$set(this.model,'fixName',user.userName);
        this.$set(this.model,'fixPhone',user.userPhone);
      },
      getteamList(){
        this.teamList = [];
        getAction(this.url.teamList).then(res=>{
          if(res.success){
            res.result.records.forEach(item=>{
              this.teamList.push({
                teamName: item.teamName,
                id: item.id,
              });
            });
          }
        });
      },
      getuserList(){
        this.userList = [];
        getAction(this.url.userList).then(res=>{
          if(res.success){
            res.result.records.forEach(item=>{
              this.userList.push({
                userId: item.userId,
                userName: item.userName,
                userPhone: item.userPhone,
              });
            });
          }
        });
      },
      init(row){
        this.visible = true;
        this.model = JSON.parse(JSON.stringify(row));
        this.$set(this.model,'fixType',0);
        if(this.model.repairState == 0){
          this.title = this.$t('报修指派');
          this.fixDisableSubmit = false;
        }else{
          this.title = this.$t('报修处理');
          this.fixDisableSubmit = true;
        }
        this.getuserList();
        this.getteamList();
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleOk() {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            postAction(this.url.editState, this.model).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
                this.visible = false;
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      handleCancel() {
        this.close()
      },
      onChange(e,row){
        debugger
        this.model.taskGroupId = e;
      }
    }
  }
</script>